import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, MouseEvent } from 'react';

export interface EmptyStateProps {
  hideTitle?: boolean;
  prefix: string;
  icon?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  e2e?: string;
  className?: string;
}
export const EmptyState: FC<EmptyStateProps> = ({
  className,
  e2e,
  icon = 'account_balance',
  prefix,
  hideTitle = false,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        className,
        'empty-state-component d-flex flex-column align-items-center justify-content-center py-5',
      )}
      data-e2e={`${e2e}-empty-state`}
    >
      <i className="icon d-inline-block mb-2">{icon}</i>
      {!hideTitle && (
        <h4 data-e2e={`${e2e}-empty-state-title`}>
          <FormattedMessage id={`${prefix}.emptyState.title` as any} />
        </h4>
      )}
      <p data-e2e={`${e2e}-empty-content`} className={classNames({ 'mb-2': onClick === undefined })}>
        <FormattedMessage id={`${prefix}.emptyState.content` as any} />
      </p>
      {onClick && (
        <div className="mt-3">
          <button
            type="button"
            className="btn btn-discreet-secondary btn-xl"
            onClick={onClick}
            data-e2e={`${e2e}-empty-state-button`}
          >
            <FormattedMessage id={`${prefix}.emptyState.action` as any} />
          </button>
        </div>
      )}
    </div>
  );
};

EmptyState.displayName = 'EmptyState';
